module.exports = __webpack_public_path__ + "static/img/skype.6e160329.png";